// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1jSND","icon":"SortAdornment_icon__dHZHI","up":"SortAdornment_up__2UZVh","down":"SortAdornment_down__1iqm1","active":"SortAdornment_active__1yHXg"};